import { alertError, alertSuccess } from 'src/shared/js/alertUtils'
import { t } from 'src/translations/src'

export const showUpdateSuccess = () => {
  alertSuccess(t('edit-account-modal.your-information-has-been-updated'))
}

export const showUpdateError = () => {
  alertError(
    t(
      'edit-account-modal.there-was-an-error-while-saving-please-refresh-the-page'
    )
  )
}

export const showEmailUpdateError = () => {
  alertError(
    t(
      'edit-account-modal.there-was-an-error-while-updating-email-please-try-again'
    )
  )
}

export const showEmailUpdateSuccess = () => {
  alertSuccess(t('profile-information.email-updated'))
}
